<template>
  <div class="empty-state-container" :style="{ height: height }">
    <div class="icon-section">
      <mf-icon color="cinza-l10" :fill="variant === 'maintenance'"> {{ icon }} </mf-icon>
    </div>
    <span>{{ variant === 'empty-state' ? 'Sem dados para exibição' : 'Em manutenção' }}</span>
  </div>
</template>

<script>
export default {
  name: 'IncrementalRevenueDetails',
  props: {
    icon: {
      type: String,
      default: 'monitoring',
    },
    height: {
      type: String,
      default: 'monitoring',
    },
    variant: {
      type: String,
      default: 'empty-state',
      validator: (value) => ['empty-state', 'maintenance'].includes(value),
    },
  },
}
</script>

<style lang="scss" scoped>
.empty-state-container {
  border: 2px dashed $cinza-l70;
  width: 100%;
  padding: 20px 0px 24px 0px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  .icon-section {
    margin: 0 auto;
    height: 44px;
    width: 44px;
    border-radius: 22px;
    background-color: $cinza-l90;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  span {
    color: $cinza-l10;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
  }
}
</style>
